import React from 'react';
import '../Style/Prototype.css'; 

const Productintro = () => {
  return (
    <div className="productintro-container">
      <div className="productintro-text">
        <h2>Prototyping and New Product Introduction (NPI)</h2>
        <p>
          Bringing new ideas to life requires speed, precision, and a partner you can trust.
          At Automotive Devices , our prototype and new product innovation (NPI) services are designed
          to help you move from concept to product quickly and efficiently. Whether you're working
          on a cutting-edge design or need rapid iterations for testing, our quick-turn prototyping
          services can deliver fully assembled boards in as little as 1–5 days.
          <br /><br />
          Our expert team collaborates with you at every stage, providing Design for Manufacturability (DFM)
          insights and ensuring that your product is ready for seamless transition to full production.
          With advanced capabilities in handling complex components like BGA, QFN, and fine-pitch parts,
          we turn your most challenging designs into reality. Whether you're a startup or an established OEM,
          we are committed to driving your innovation forward with flexible, high-quality PCB prototypes
          that meet the demands of today’s fast-paced markets.
        </p>
      </div>

      <div className="productintro-image">
        <img src="/prototype.jpeg" alt="Prototyping and NPI" />
      </div>
    </div>
  );
};

export default Productintro;
